import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import SecureAvatar from 'components/common/SecureAvatar';

export const DetailSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1rem',
  color: '#222',
  marginBottom: theme.spacing(2),
}));

export const WorkerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const WorkerAvatar = styled(SecureAvatar)(({ theme }) => ({
  width: 56,
  height: 56,
}));

export const WorkerName = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.1rem',
  color: '#222',
  marginBottom: theme.spacing(0),
}));

export const WorkerDetailText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#666',
  marginBottom: theme.spacing(0.25),
}));
